import React from 'react';
import LicenseGenerator from './LicenseGenerator';
import LicenseVerifier from './LicenseVerifier';

// ─── Licenses Page — Generate License only (All Licenses, Renewal Manager, Pricing Config
//     are available as dedicated sidebar menu items) ───────────────────────────
export default function LicensesPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <LicenseGenerator />
      <LicenseVerifier />
    </div>
  );
}
